// fetched either from Hafgufa or .env file
const ENVIRONMENT =
  (window.frameElement && window.frameElement.getAttribute("data-environment")) ||
  (process && process.env && process.env.REACT_APP_ENVIRONMENT);

export { ENVIRONMENT };
